<template>
<div>
    <v-toolbar class="py-1 mb-3" light app v-if="isUserLoggedIn">
        <!-- <v-toolbar-title class="text-uppercase grey--text"></v-toolbar-title> -->

        <img max-height="60px" width="200px" contain src="/glue_logo_2.png" />
        <v-breadcrumbs :key="keyCrumbs" :items="crumbsItems">
            <v-breadcrumbs-item :disabled="item.disabled" slot="item" slot-scope="{ item }" exact :to="item.to">
                {{ item.text }}
            </v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-spacer></v-spacer>

        <!-- <v-flex xs6 v-if="$store.state.currentOrg.org.isPrimaryOrganisation&&$store.state.currentOrg.org.id===1">
        <v-autocomplete
        clearable
        no-filter
        v-model="select"
          :search-input.sync="search"
          return-object
          :items="searchResults"
          :loading="isLoading"
          single-line
          solo
          hide-no-data
          flat
          color="primary"
          label="Search"
          item-text="name"
          item-value="id"
        >
          <template v-slot:selection="data">{{ data.item.name }}</template>
          <template v-slot:item="data">
            <template v-if="data.item.type==='header'">
              <v-list-tile disabled>
              <v-list-tile-avatar>
                    <v-icon>{{data.item.icon}}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
              </v-list-tile-content>
              </v-list-tile>
            </template>
            <template v-else>
              <v-list-tile-content>
                <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>-->
        <v-list-tile xs6 sm3 md3 lg3>
            <v-badge :key="agreementKey" color="primary" overlap v-if="outstandingAgreements.length>0">

                <template v-slot:badge>
                    <span>{{ outstandingAgreements.length }}</span>
                </template>
                <v-btn small style="border-radius: 5px; color: grey; font-size: 12px" outline @click="showOutstandingDocuments = true, selectedDocument = outstandingAgreements[0]">
                    <v-icon small class="mr-1">description</v-icon>
                    Documents
                </v-btn>
            </v-badge>
            <v-badge class="mx-2" :key="key" color="primary" overlap>
                <template v-slot:badge>
                    <span>{{ notificationUserRoles.length }}</span>
                </template>
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" class="hidden-sm-and-down">
                            <v-icon large style="cursor: pointer">info</v-icon>
                        </v-btn>
                    </template>
                    <v-list class="scroll-y" style="max-height:450px" three-line>
                        <template v-for="item in notificationUserRoles">
                            <v-list-tile :key="item.type" avatar style="cursor: pointer">
                                <v-layout align-center justify-center>
                                    <v-list-tile-avatar style="margin-top:1px" @click="routerLinkToDetails(item)">
                                        <v-img contain :key="$store.state.currentOrg.org.logo" :src="$store.state.currentOrg.org.logo"></v-img>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content align-center @click="routerLinkToDetails(item)">
                                        <v-list-tile-title v-html="item.type"></v-list-tile-title>
                                        <v-list-tile-sub-title v-if="item.type == 'New Service Account'" v-html="item.description.split(' \nLocation: ', 1)[0]"></v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-if="item.type == 'New Service Account'" v-html="item.description.split(' \nLocation: ')[1]"></v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-else v-html="item.description"></v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-html="formatDate(item.createdAt)"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-item-action>
                                        <v-btn @click="closeNotification(item)" icon>
                                            <v-icon color="grey lighten-1">clear</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-layout>
                            </v-list-tile>
                        </template>
                        <template v-if="notificationUserRoles.length > 1">
                            <v-list-tile @click="bulkClose()" style="cursor: pointer" avatar>
                                <v-layout align-center justify-center>
                                    <v-list-tile-avatar style="margin-top:1px">
                                        <v-img contain :src="$store.state.currentOrg.org.logo"></v-img>
                                    </v-list-tile-avatar>

                                    <v-list-tile-title class="grey--text">Clear All Notifications</v-list-tile-title>
                                </v-layout>
                            </v-list-tile>
                        </template>
                        <template v-if="notificationUserRoles.length === 0">
                            <v-list-tile avatar>
                                <v-layout align-center justify-center>
                                    <v-list-tile-avatar style="margin-top:1px">
                                        <v-img contain :src="$store.state.currentOrg.org.logo"></v-img>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content align-center>
                                        <v-list-tile-title class="grey--text">You currently have no notifications</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-layout>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-menu>
            </v-badge>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="hidden-sm-and-down">
                        <v-icon style="cursor: pointer" @click="pushToJira()">bug_report</v-icon>

                    </v-btn>
                </template>
                <span>Log Issues</span>
            </v-tooltip>

            <v-tooltip bottom class="mx-1">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="hidden-sm-and-down" @click="helpModal = true">
                        <v-icon v-on="on" style="cursor: pointer">help</v-icon>
                    </v-btn>
                </template>
                <span>Help</span>
            </v-tooltip>

            <v-tooltip bottom class="mx-1">
                <template v-slot:activator="{ on }">
                    <v-btn icon class="hidden-sm-and-down" v-on="on">
                        <v-icon style="cursor: pointer" @click="dialog = true">account_circle</v-icon>

                    </v-btn>
                </template>
                <span>Edit Account Details</span>
            </v-tooltip>

            <v-list-tile-content class="hidden-sm-and-down">
                <v-list-tile-title class="font-weight-bold">{{ user.name }} {{ user.surname }}</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-tooltip bottom class="mx-2">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                    <v-icon style="cursor: pointer" @click="logout()">exit_to_app</v-icon>
                </v-btn>

            </template>
            <span>Logout</span>
        </v-tooltip>
    </v-toolbar>

    <v-dialog persistent v-model="dialog" max-width="750px">
        <v-card>
            <v-toolbar flat class="white">
                <v-toolbar-title>
                    ACCOUNT DETAILS
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <h3 dark-grey--text>Personal Details</h3>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <v-text-field v-model="user.name" label="*First Name" persistent-hint required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <v-text-field v-model="user.surname" label="*Surname" persistent-hint required></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <v-text-field v-model="user.idNumber" label="*RSA ID Number or Passport Number" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <h3 dark-grey--text>Contact Details</h3>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <v-text-field v-model="user.mobileNumber" label="*Mobile Number" persistent-hint></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                            <v-text-field v-model="user.telephoneNumber" label="Telephone Number" persistent-hint></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <h3 dark-grey--text>Login Settings</h3>
                        </v-flex>

                        <v-flex xs12 sm3 md6>
                            <v-text-field v-model="user.emailAddress" prepend-icon="email" label="*Email Address" persistent-hint type="email"></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                            <v-text-field v-model="password" prepend-icon="security" label="Reset Password"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm2 md2>
                            <v-btn flat color="primary" @click="resetPassword">Reset</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions class="justify-center layout px-0">
                <v-btn color="primary" round @click="dialog = false">Cancel</v-btn>
                <v-btn color="primary" round @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <nav width="7500px">
        <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" hide-overlay stateless dark app class="navbarColour" width="320px">
            <v-layout column align-Left>
                <!-- <v-toolbar height="70px" flat class="transparent text-md-center">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <img @click.stop="mini = !mini" height="50px" id="headImg" src="/dpIcon.png" />
                <v-toolbar-title class="text-uppercase white--text" v-show="!mini">
                  <span v-for="name in config.portalName.split(' ')" :key="name">
                    <span
                      class="font-weight-bold grey--text"
                      v-if="isEven(config.portalName.split(' ').indexOf(name))"
                    >{{name}}</span>
                    <span class="font-weight-light grey--text" v-else>{{name}}</span>
                  </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-list-tile-action>
                  <v-btn icon @click.stop="mini = !mini">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-divider></v-divider> -->
                <!-- <v-toolbar height="70px" flat class="transparent text-md-center"> -->
                <v-menu offset-x v-if="!mini">
                    <template v-slot:activator="{ on }">
                        <v-list>
                            <v-list-tile v-on="on" style="width: 100%">
                                <v-list-tile-action>
                                    <v-avatar class="white">
                                        <v-img contain alt="Avatar" v-if="$store.state.currentOrg.org" :key="$store.state.currentOrg.org.logo" :src="$store.state.currentOrg.org.logo" />
                                    </v-avatar>

                                </v-list-tile-action>

                                <v-list-tile-content>
                                    <v-list-tile-title class="navbarTextColour--text" v-show="!mini">
                                        <span class="font-weight-light">{{
                        $store.state.currentOrg.org.name
                      }}</span>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <!-- <v-toolbar-title class="navbarTextColour--text" v-show="!mini">
                      <span v-resize-text class="font-weight-light mr-3" wrap>{{
                        $store.state.currentOrg.org.name
                      }}</span>
                    </v-toolbar-title> -->
                                <v-list-tile-action>
                                    <v-btn icon @click.stop="mini = !mini">
                                        <v-icon>chevron_left</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </template>
                    <v-list>
                        <v-list-tile v-for="(item, index) in $store.state.organisations.filter(
                    (x) => x.orgId != $store.state.currentOrg.orgId
                  )" :key="index" @click="changeOrganisation(item)">
                            <v-list-tile-avatar>
                                <v-img :key="item.org.logo" contain :src="item.org.logo" />
                            </v-list-tile-avatar>
                            <v-list-tile-subtitle wrap>{{ item.org.name }}</v-list-tile-subtitle>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-avatar class="white ml-3 mt-2" v-else @click="mini = !mini">
                    <v-img contain alt="Avatar" v-if="$store.state.currentOrg.org" :key="$store.state.currentOrg.org.logo" :src="$store.state.currentOrg.org.logo" />
                </v-avatar>
                <!-- </v-toolbar> -->
                <v-divider></v-divider>
                <v-list>
                    <!-- <v-list my-0 py-0 > -->
                    <v-list-tile v-for="item in navbarList.filter((x) => !x.group)" :key="item.title" :to="item.route" @click="setCurrentRoute(item.route)">
                        <v-list-tile-action>
                            <v-icon size="16px">{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content wrap>
                            <v-list-tile-subtitle wrap>
                                <b style="fontSize: 15px">{{ item.title }}</b>
                            </v-list-tile-subtitle>
                        </v-list-tile-content>
                    </v-list-tile>
                    <!-- </v-list> -->
                    <v-list-group wrap class="font-weight-thin body-2 navbarTextColour--text" v-for="item in navbarList.filter((x) => x.group)" :key="item.title" :id="item.id" :prepend-icon="item.icon" no-action v-model="item.active">
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-content wrap>
                                    <v-list-tile-subtitle wrap>
                                        <b style="fontSize: 15px">{{ item.title }}</b>
                                    </v-list-tile-subtitle>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>

                        <v-list-tile v-for="subItem in item.items.filter((x) => !x.items)" :key="subItem.title" :id="subItem.id" router :to="subItem.route" @click="setCurrentRoute(subItem.route)">
                            <v-list-tile-content wrap>
                                <v-divider color="white"></v-divider>
                                <v-list-tile-subtitle style="fontSize: 15px">{{ subItem.title }}</v-list-tile-subtitle>
                                <v-divider color="grey"></v-divider>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list-group>
                </v-list>
            </v-layout>
        </v-navigation-drawer>
    </nav>

    <v-dialog v-model="helpModal" persistent width="1024px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>User Guide</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="downloadUserGuide()" v-if="!loadingDownload">
                    <v-icon>download</v-icon>
                </v-btn> -->
                <!-- <v-progress-circular v-else indeterminate color="grey" size="20"></v-progress-circular> -->
                <v-btn flat @click="helpModal = false">X</v-btn>
            </v-toolbar>
            <v-card-text style="text-align: left; overflow-y: auto; max-height: 75vh">
                <vue-markdown :source="helpData"></vue-markdown>
                <!-- <vue-simple-markdown
           style="overflow-y: auto; max-height: 80vh"
                class="text-xs-left"
                :image="true"
                :source="helpData"
              ></vue-simple-markdown> -->
                <!-- <span>{{helpData}}</span> -->
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="showOutstandingDocuments" :persistent="persistDocumentAccept" width="1024px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>My Digital Documents</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat v-if="!persistDocumentAccept" @click="showOutstandingDocuments = false">X</v-btn>
            </v-toolbar>
            <v-card-text style="text-align: left; overflow-y: auto; max-height: 75vh">
                <v-layout justify-start v-if="outstandingAgreements.length>0">
                    <v-flex xs3>
                        <v-list dense subheader>
                            <v-subheader style="background: #f0f0f0">Outstanding Documents</v-subheader>
                            <v-list-tile v-for="document in outstandingAgreements" :key="document.id" @click="selectedDocument=document">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 12px">
                                        {{document.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 12px">
                                        Due {{document.date}}
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="selectedDocument&&selectedDocument.id==document.id">
                                    <v-icon color="green">check</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs9 class="pl-2">
                        <v-toolbar flat color="white" v-if="selectedDocument&&selectedDocument.name">
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                                {{selectedDocument.name}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="!acceptingAgreement&&!selectedDocument.accepted" outline color="green" @click="acceptAgreement(selectedDocument)">
                                <v-icon class="mr-1">check</v-icon>
                                Accept
                            </v-btn>
                            <v-progress-circular v-else-if="!accepted&&acceptingAgreement" indeterminate color="green" size="24"></v-progress-circular>
                            <v-btn v-else disabled>
                                <v-icon class="mr-1">check</v-icon>
                                Accepted
                            </v-btn>
                        </v-toolbar>
                        <vue-markdown v-if="selectedDocument&&selectedDocument.content" :source="selectedDocument.content"></vue-markdown>

                    </v-flex>
                </v-layout>
                <!-- <vue-simple-markdown
           style="overflow-y: auto; max-height: 80vh"
                class="text-xs-left"
                :image="true"
                :source="helpData"
              ></vue-simple-markdown> -->
                <!-- <span>{{helpData}}</span> -->
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import {
    mapState
} from "vuex";
import Api from "@/services/Api";
import axios from 'axios'
// import Push from "push.js";
import configData from "../../../config/config.json";
import dateformat from "dateformat";
import VueMarkdown from 'vue-markdown'
export default {
    components: {
        VueMarkdown
    },
    props: ["primaryColour"],
    watch: {
        '$store.state.currentOrg': {
            immediate: true,
            handler(value) {
                this.crumbsItems = []
            }
        },
        "$route.path": {
            immediate: true,
            handler(value) {
                if (value == "/fibrePlanner") {
                    this.mini = true;
                }
                // Contractor Faults on a phone: icons-only menu, so the job list has the screen.
                if (value == "/contractorFaults" && this.$vuetify.breakpoint.smAndDown) {
                    this.mini = true;
                }
                if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/networkOperators/:networkOperatorId"
                ) {
                    Api()
                        .get("/organisation/basic/" + this.$route.params.networkOperatorId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Manage ISP Packages",
                                    disabled: false,
                                    to: "/networkOperators",
                                },
                                {
                                    text: response.data.name,
                                    disabled: true,
                                    to: "/networkOperators/" + this.$route.params.networkOperatorId,
                                },
                            ];
                            this.keyCrumbs++;
                        });
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/packageSummary/:locationNetworkId"
                ) {
                    Api()
                        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Manage ISP Packages",
                                    disabled: false,
                                    to: "/networkOperators",
                                },
                                {
                                    text: response.data.organisation.name,
                                    disabled: false,
                                    to: "/networkOperators/" + response.data.organisationId,
                                },
                                {
                                    text: "Packages: " + response.data.name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/globalPackageSummary/:packagesIspId"
                ) {
                    Api()
                        .get("/customer/packagesIsps/" + this.$route.params.packagesIspId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Manage ISP Packages",
                                    disabled: false,
                                    to: "/networkOperators",
                                },
                                {
                                    text: response.data[0].supplierOrganisation.name,
                                    disabled: false,
                                    to: "/networkOperators/" + response.data[0].supplierOrganisationId,
                                },
                                {
                                    text: "Global Packages: " + response.data[0].name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/serviceLevelAgreement/:serviceLevelAgreementId"
                ) {
                    Api()
                        .get("/sla/" + this.$route.params.serviceLevelAgreementId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Service Level Agreements",
                                    disabled: false,
                                    to: "/serviceLevelAgreement",
                                },
                                {
                                    text: "Customer: " + response.data.customerOrganisation.name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/switchingCentres/:switchingCentreId"
                ) {
                    Api()
                        .get("/switchingCentres/" + this.$route.params.switchingCentreId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Switching Centres",
                                    disabled: false,
                                    to: "/switchingCentres",
                                },
                                {
                                    text: response.data[0].name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/locationNodes/:locationNodeId"
                ) {
                    Api()
                        .get("/locationNodes/" + this.$route.params.locationNodeId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Nodes",
                                    disabled: false,
                                    to: "/locationNodes",
                                },
                                {
                                    text: response.data[0].name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/locationNetworks/:locationNetworkId"
                ) {
                    Api()
                        .get("/locationNetworks/" + this.$route.params.locationNetworkId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Networks",
                                    disabled: false,
                                    to: "/locationNetwork",
                                },
                                {
                                    text: response.data.name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/locationNetworks/:locationNetworkId/:locationId"
                ) {
                    Api()
                        .get("/Locations/" + this.$route.params.locationId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Locations",
                                    disabled: false,
                                    to: "/locations",
                                },
                                {
                                    text: response.data[0].locationDescription,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/applications/:applicationId"
                ) {
                    this.crumbsItems = [{
                            text: "Applications",
                            disabled: false,
                            to: "/applications",
                        },
                        {
                            text: "ID: " + this.$route.params.applicationId,
                            disabled: true,
                        },
                    ];
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/ispApplications/:applicationId"
                ) {
                    this.crumbsItems = [{
                            text: "Applications",
                            disabled: false,
                            to: "/applications",
                        },
                        {
                            text: "ID: " + this.$route.params.applicationId,
                            disabled: true,
                        },
                    ];
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/contactSummary/:contactId"
                ) {
                    Api()
                        .get("/contact/basic/" + this.$route.params.contactId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Contacts",
                                    disabled: false,
                                    to: "/contacts",
                                },
                                {
                                    text: response.data.name + " " + response.data.surname,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (this.$store.state.currentRoute && this.$store.state.currentRoute.url === "/devices/:deviceId") {
                    Api()
                        .get("/devices/" + this.$route.params.deviceId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Devices",
                                    disabled: false,
                                    to: "/devices",
                                },
                                {
                                    text: response.data.systemName,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/serviceAccounts/:serviceAccountId"
                ) {
                    Api()
                        .get("/serviceAccounts/" + this.$route.params.serviceAccountId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Service Accounts",
                                    disabled: false,
                                    to: "/serviceAccounts",
                                },
                                {
                                    text: "Circuit Number: " + response.data.circuitNumber,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/isp/serviceAccounts/:serviceAccountId"
                ) {
                    Api()
                        .get("/customer/serviceAccounts/" + this.$route.params.serviceAccountId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Service Accounts",
                                    disabled: false,
                                    to: "/ispServiceAccounts",
                                },
                                {
                                    text: "Circuit Number: " + response.data.circuitNumber,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/ticketSummary/:ticketId"
                ) {
                    this.crumbsItems = [{
                            text: "Tickets",
                            disabled: false,
                            to: "/tickets",
                        },
                        {
                            text: "ID: " + this.$route.params.ticketId,
                            disabled: true,
                        },
                    ];
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/ispTicketSummary/:ticketId"
                ) {
                    this.crumbsItems = [{
                            text: "Tickets",
                            disabled: false,
                            to: "/ispTickets",
                        },
                        {
                            text: "ID: " + this.$route.params.ticketId,
                            disabled: true,
                        },
                    ];
                    this.keyCrumbs++;
                } else if (this.$store.state.currentRoute && this.$store.state.currentRoute.url === "/userRoles/:userRoleId") {
                    Api()
                        .get("/userRole/" + this.$route.params.userRoleId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "UserRoles",
                                    disabled: false,
                                    to: "/userRoles",
                                },
                                {
                                    text: response.data.name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else if (
                    this.$store.state.currentRoute &&
                    this.$store.state.currentRoute.url === "/organisation/isp/:organisationId"
                ) {
                    Api()
                        .get("/organisation/basic/" + this.$route.params.organisationId)
                        .then((response) => {
                            this.crumbsItems = [{
                                    text: "Sub Organisations",
                                    disabled: false,
                                    to: "/organisation/isp",
                                },
                                {
                                    text: response.data.name,
                                    disabled: true,
                                },
                            ];
                        });
                    this.keyCrumbs++;
                } else {
                    this.crumbsItems = [];
                    this.keyCrumbs += 1;
                }
            },
        },
        select(value) {
            if (value.type === "Location") {
                this.$router.push({
                    path: "/locationNetworks/" + value.locationNetworkId + "/" + value.id,
                });
            } else if (value.type === "Contact") {
                this.$router.push({
                    path: "/contactSummary/" + value.id,
                });
            } else if (value.type === "Service Account") {
                this.$router.push({
                    path: "/locationNetworks/" + value.locationNetworkId + "/" + value.locationId,
                });
            } else if (value.type === "Device") {
                if (value.locationId !== null) {
                    this.$router.push({
                        path: "/locationNetworks/" + value.locationNetworkId + "/" + value.locationId,
                    });
                } else if (value.locationId === null && value.locationNetworkId !== null) {
                    this.$router.push({
                        path: "/locationNetworks/" + value.locationNetworkId,
                    });
                } else if (value.locationId === null && value.locationNetworkId === null && value.locationNodeId !== null) {
                    this.$router.push({
                        path: "/locationNodes/" + value.locationNodeId,
                    });
                } else if (
                    value.locationId === null &&
                    value.locationNetworkId === null &&
                    value.locationNodeId === null &&
                    value.switchingCentreId !== null
                ) {
                    this.$router.push({
                        path: "/switchingCentres/" + value.switchingCentreId,
                    });
                }
            }
        },
        // async search(value) {
        //   this.isLoading = true;
        //   if (
        //     typeof value === "undefined" ||
        //     value === null ||
        //     value.length === 0 ||
        //     value === ""
        //   ) {
        //     this.searchResults = [];
        //   } else {
        //     // this.searchResults = [];

        //     await Api()
        //       .get("/contacts/elasticSearch", {
        //         params: {
        //           search: value,
        //         },
        //       })
        //       .then(async (response) => {
        //         for (var i = this.searchResults.length - 1; i >= 0; --i) {
        //           if (
        //             this.searchResults[i].type == "Contact" ||
        //             (this.searchResults[i].type === "header" &&
        //               this.searchResults[i].name === "Contacts")
        //           ) {
        //             this.searchResults.splice(i, 1);
        //           }
        //         }
        //         if (response.data.length >= 1) {
        //           this.searchResults.push({ divider: true, type: "Contact" });
        //           this.searchResults.push({
        //             icon: "person",
        //             name: "Contacts",
        //             type: "header",
        //           });
        //           this.searchResults.push({ divider: true, type: "Contact" });
        //           for (let i = 0; i < response.data.length; i++) {
        //             await this.searchResults.push({
        //               id: response.data[i].id,
        //               icon: "person",
        //               name:
        //                 response.data[i].name +
        //                 " " +
        //                 response.data[i].surname +
        //                 " | " +
        //                 response.data[i].mobileNumber +
        //                 " | " +
        //                 response.data[i].telephoneNumber +
        //                 " | " +
        //                 response.data[i].emailAddress,
        //               type: "Contact",
        //             });
        //           }
        //           // this.searchResults.push({ divider: true });
        //         }
        //       });
        //     await Api()
        //       .get("/serviceAccounts/elasticSearch", {
        //         params: {
        //           search: value,
        //         },
        //       })
        //       .then(async (response) => {
        //         for (var i = this.searchResults.length - 1; i >= 0; --i) {
        //           if (
        //             this.searchResults[i].type == "Service Account" ||
        //             (this.searchResults[i].type === "header" &&
        //               this.searchResults[i].name === "Service Accounts")
        //           ) {
        //             this.searchResults.splice(i, 1);
        //           }
        //         }
        //         if (response.data.length >= 1) {
        //           this.searchResults.push({
        //             divider: true,
        //             type: "Service Account",
        //           });
        //           this.searchResults.push({
        //             icon: "build",
        //             name: "Service Accounts",
        //             type: "header",
        //           });
        //           this.searchResults.push({
        //             divider: true,
        //             type: "Service Account",
        //           });

        //           for (let i = 0; i < response.data.length; i++) {
        //             await this.searchResults.push({
        //               id: response.data[i].id,
        //               icon: "build",
        //               locationId: response.data[i].locationId,
        //               locationNetworkId:
        //                 response.data[i].location.locationNetworkId,
        //               name:
        //                 response.data[i].pppoeUsername +
        //                 " | " +
        //                 response.data[i].pppoePassword,
        //               type: "Service Account",
        //             });
        //           }
        //           // this.searchResults.push({ divider: true });
        //         }
        //       });

        //     await Api()
        //       .get("/locations/elasticSearch", {
        //         params: {
        //           search: value,
        //         },
        //       })
        //       .then(async (response) => {
        //         for (var i = this.searchResults.length - 1; i >= 0; --i) {
        //           if (
        //             this.searchResults[i].type == "Location" ||
        //             (this.searchResults[i].type === "header" &&
        //               this.searchResults[i].name === "Locations")
        //           ) {
        //             this.searchResults.splice(i, 1);
        //           }
        //         }
        //         if (response.data.length >= 1) {
        //           this.searchResults.push({ divider: true, type: "Location" });
        //           this.searchResults.push({
        //             icon: "location_on",
        //             name: "Locations",
        //             type: "header",
        //           });
        //           this.searchResults.push({ divider: true, type: "Location" });
        //           for (let i = 0; i < response.data.length; i++) {
        //             await this.searchResults.push({
        //               id: response.data[i].id,
        //               icon: "location_on",
        //               locationNetworkId: response.data[i].locationNetworkId,
        //               name:
        //                 response.data[i].unitNo +
        //                 " | " +
        //                 response.data[i].locationNetwork.name,
        //               type: "Location",
        //             });
        //           }
        //           // this.searchResults.push({ divider: true });
        //         }
        //       });

        //     await Api()
        //       .get("/devices/elasticSearch", {
        //         params: {
        //           search: value,
        //         },
        //       })
        //       .then(async (response) => {
        //         for (var i = this.searchResults.length - 1; i >= 0; --i) {
        //           if (
        //             this.searchResults[i].type == "Device" ||
        //             (this.searchResults[i].type === "header" &&
        //               this.searchResults[i].name === "Devices")
        //           ) {
        //             this.searchResults.splice(i, 1);
        //           }
        //         }
        //         if (response.data.length >= 1) {
        //           this.searchResults.push({ divider: true, type: "Device" });
        //           this.searchResults.push({
        //             icon: "devices",
        //             name: "Devices",
        //             type: "header",
        //           });
        //           this.searchResults.push({ divider: true, type: "Device" });
        //           for (let i = 0; i < response.data.length; i++) {
        //             await this.searchResults.push({
        //               id: response.data[i].id,
        //               icon: "devices",
        //               locationId: response.data[i].locationId,
        //               locationNetworkId: response.data[i].locationNetworkId,
        //               locationNodeId: response.data[i].locationNodeId,
        //               switchingCentreId: response.data[i].switchingCentreId,
        //               name:
        //                 response.data[i].systemName +
        //                 " | " +
        //                 response.data[i].ponMac +
        //                 " | " +
        //                 response.data[i].serialNumber,
        //               type: "Device",
        //             });
        //           }
        //           // this.searchResults.push({ divider: true });
        //         }
        //       });
        //   }
        //   this.isLoading = false;
        // },
    },

    methods: {
        async acceptAgreement(agreement) {
            this.acceptingAgreement = true
            await Api().put('/agreements/sign/' + agreement.id).then(response => {
                const linkSource = `${response.data}`;
                const downloadLink = document.createElement("a");
                const fileName = agreement.name + '.pdf'
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                agreement.acceptedBy = this.$store.state.user
                agreement.accepted = true
                agreement.acceptedDate = new Date()
                this.acceptingAgreement = false
                if(this.outstandingAgreements.length>0){
                    this.persistDocumentAccept = this.outstandingAgreements.filter(x=>this.isFuture(x.date)&&!x.accepted).length>0
                    if(this.persistDocumentAccept){
                        this.selectedDocument = this.outstandingAgreements[0]
                        this.showOutstandingDocuments = true
                    }
                }
            })
        },
        async fetchUserGuide() {
            // let aws = await axios.create({})
            Api().get('/ispUserGuide').then(res => {
                // console.log(res)
                this.helpData = res.data.content
                // console.log(this.helpData)
            })
        },
        downloadUserGuide() {
            this.loadingDownload = true
            Api().post('/convertMd', this.helpData.toString()).then(response => {
                console.log(response.data)
                let file = Buffer.from(response.data, "base64");
                const linkSource = `data:application/pdf;base64,${response.data}`;
                const downloadLink = document.createElement("a");
                const fileName = 'user_guide.pdf'

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                this.loadingDownload = false

            })
        },
        pushToJira() {
            window.open(this.config.jiraLink, "_blank");
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy HH:MM");
            } else {
                null;
            }
        },
        bulkClose() {
            let updateArr = [];
            for (let k = 0; k < this.notificationUserRoles.length; k++) {
                updateArr.push({
                    id: this.notificationUserRoles[k].id,
                    contactId: this.notificationUserRoles[k].contactId,
                    organisationId: this.notificationUserRoles[k].organisationId,
                    seen: true,
                });
            }
            Api()
                .post("/notifications/bulkClose/" + this.$store.state.user.id + "/" + this.$store.state.currentOrg.org.id, {
                    batch: updateArr,
                })
                .then((response) => {
                    this.fetchNotifications();
                });
        },
        fetchNotifications() {
            Api()
                .get("/notifications/ByContact/" + this.$store.state.user.id + "/" + this.$store.state.currentOrg.org.id)
                .then((response) => {
                    this.notificationUserRoles = response.data;
                    this.notificationUserRoles.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                });
        },
        closeNotification(item) {
            Api()
                .put("/notifications/" + item.id, {
                    seen: true,
                })
                .then(async () => {
                    let idArray = await this.notificationUserRoles.map((x) => x.id);
                    let index = idArray.indexOf(item.id);
                    this.notificationUserRoles.splice(index, 1);
                });
        },

        async routerLinkToDetails(item) {
            if (item.applicationId != null && item.type == "New Application") {
                this.editedItem = Object.assign({}, item);
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/applications/:applicationId") {
                        return el.url === "/applications/:applicationId";
                    } else if (el.url === "/ispApplications/:applicationId") {
                        return el.url === "/ispApplications/:applicationId";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    if (route[0].url == "/applications/:applicationId") {
                        this.$router.push({
                            path: "/applications/" + this.editedItem.applicationId,
                        });
                    } else if (route[0].url == "/ispApplications/:applicationId") {
                        this.$router.push({
                            path: "/ispApplications/" + this.editedItem.applicationId,
                        });
                    }
                }
                Api()
                    .get("/notifications/byApplicationId/" + this.editedItem.applicationId)
                    .then((response) => {
                        for (let i = 0; i < response.data.length; i++) {
                            Api().put("/notifications/contact/" + response.data[i].id + "/" + this.$store.state.user.id, {
                                seen: true,
                            });
                        }

                        this.fetchNotifications();
                    });
            } else if (item.applicationId != null && item.type == "New Lead") {
                this.editedItem = Object.assign({}, item);
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/applications/lead/:applicationId") {
                        return el.url === "/applications/lead/:applicationId";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    if (route[0].url == "/applications/lead/:applicationId") {
                        this.$router.push({
                            path: "/applications/lead/" + this.editedItem.applicationId,
                        });
                    }
                }
                Api()
                    .get("/notifications/byApplicationId/" + this.editedItem.applicationId)
                    .then((response) => {
                        for (let i = 0; i < response.data.length; i++) {
                            Api().put("/notifications/contact/" + response.data[i].id + "/" + this.$store.state.user.id, {
                                seen: true,
                            });
                        }

                        this.fetchNotifications();
                    });
            } else if (item.serviceAccountId != null) {
                let path = "";
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/serviceAccounts") {
                        return el.url === "/serviceAccounts";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    path = "/serviceAccounts";
                } else {
                    await this.$store.dispatch("setCurrentRoute", "/ispServiceAccounts");
                    path = "/ispServiceAccounts";
                }

                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: path
                });

                Api()
                    .get("/notifications/byServiceAccountId/" + this.editedItem.serviceAccountId)
                    .then((response) => {
                        let id = response.data.id;
                        Api()
                            .put("/notifications/contact/" + id + "/" + this.$store.state.user.id, {
                                seen: true,
                            })
                            .then((response) => {
                                this.fetchNotifications();
                            });
                    });
            } else if (item.ispLocationNetworkId != null) {
                let path = "";
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/locationNetworks/:locationNetworkId") {
                        return el.url === "/locationNetworks/:locationNetworkId";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    path = "/locationNetworks/";
                } else {
                    await this.$store.dispatch("setCurrentRoute", "/packageSummary/:locationNetworkId");
                    path = "/packageSummary/";
                }

                this.editedItem = Object.assign({}, item);
                Api()
                    .get("/ispLocationNetworks/getById/" + this.editedItem.ispLocationNetworkId)
                    .then((response) => {
                        this.$router.push({
                            path: path + response.data.locationNetworkId
                        });
                        Api()
                            .get("/notifications/byIspLocationNetworkId/" + this.editedItem.ispLocationNetworkId)
                            .then((response) => {
                                let id = response.data.id;
                                Api()
                                    .put("/notifications/contact/" + id + "/" + this.$store.state.user.id, {
                                        seen: true,
                                    })
                                    .then((response) => {
                                        this.fetchNotifications();
                                    });
                            });
                    });
            } else if (item.ticketId != null) {
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/ticketSummary/:ticketId") {
                        return el.url === "/ticketSummary/:ticketId";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    this.$router.push({
                        path: "/ticketSummary/" + item.ticketId
                    });
                }
                this.editedItem = Object.assign({}, item);
                Api()
                    .get("/notifications/byTicketId/" + this.editedItem.ticketId)
                    .then((response) => {
                        let id = response.data.id;
                        Api()
                            .put("/notifications/contact/" + id + "/" + this.$store.state.user.id, {
                                seen: true,
                            })
                            .then((response) => {
                                this.fetchNotifications();
                            });
                    });
            } else if (item.serviceAccountAuditLogId !== null) {
                let path = "";
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/serviceAccounts") {
                        return el.url === "/serviceAccounts";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    path = "/serviceAccounts";
                } else {
                    await this.$store.dispatch("setCurrentRoute", "/ispServiceAccounts");
                    path = "/ispServiceAccounts";
                }

                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: path
                });

                Api()
                    .get("/notifications/byServiceAccountAuditLogId/" + this.editedItem.serviceAccountAuditLogId)
                    .then((response) => {
                        for (let y = 0; y < response.data.length; y++) {
                            let id = response.data[y].id;
                            Api()
                                .put("/notifications/contact/" + id + "/" + this.$store.state.user.id, {
                                    seen: true,
                                })
                                .then((response) => {
                                    this.fetchNotifications();
                                });
                        }
                    });
            } else if (item.packagesFnoId != null) {
                let path = "";
                let url = item;
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    if (el.url === "/networkOperators") {
                        return el.url === "/networkOperators";
                    }
                });
                if (route[0]) {
                    await this.$store.dispatch("setCurrentRoute", route[0]);
                    path = "/networkOperators";
                }

                this.editedItem = Object.assign({}, item);

                this.$router.push({
                    path: path
                });
                Api()
                    .get("/notifications/packagesFnoId/" + this.editedItem.packagesFnoId)
                    .then((response) => {
                        let id = response.data.id;
                        Api()
                            .put("/notifications/contact/" + id + "/" + this.$store.state.user.id, {
                                seen: true,
                            })
                            .then((response) => {
                                this.fetchNotifications();
                            });
                    });
            }
        },
        async getNavbarList() {
            this.navbarList = [];
            this.fetchOrganisationAgreements()
            for (let i = 0; i < this.items.length; i++) {
                this.navbarList.push(this.items[i]);
                this.items[i].isActive = false;

                let tempList = [];
                if (this.items[i].items.length > 0) {
                    for (let x = 0; x < this.items[i].items.length; x++) {
                        if (this.$store.state.currentOrg.org.frontendRoutes.includes(this.items[i].items[x].route)) {
                            this.items[i].isActive = true;
                            if (!tempList.includes(this.items[i].items[x])) {
                                tempList.push(this.items[i].items[x]);
                            }
                        }
                    }
                } else {
                    if (this.$store.state.currentOrg.org.frontendRoutes.includes(this.items[i].route)) {
                        this.items[i].isActive = true;
                    }
                }
                if (tempList.length > 0) {
                    this.navbarList[i].isGroup = true;
                } else {
                    this.navbarList[i].isGroup = false;
                }
                this.navbarList[i].items = tempList;
            }
            Api()
                .get("/authenticate/email/" + this.$store.state.user.emailAddress)
                .then((response) => {
                    if (response.data.auth === true) {
                        this.navbarList.push(this.admin);
                    }
                });
            this.navbarList = await this.navbarList.filter(function (el) {
                return el.isActive;
            });
            this.allRoutes = [];
            let routes = this.navbarList.map((x) => x.items.map((y) => y.route));
            for (let a = 0; a < routes.length; a++) {
                for (let b = 0; b < routes[a].length; b++) {
                    this.allRoutes.push(routes[a][b]);
                }
            }
        },
        save() {
            Api().put("/contacts/" + this.user.id, {
                name: this.user.name,
                surname: this.user.surname,
                idNumber: this.user.idNumber,
                mobileNumber: this.user.mobileNumber,
                telephoneNumber: this.user.telephoneNumber,
                permissions: this.user.permissions,
                emailAddress: this.user.emailAddress,
                isActive: this.user.isActive,
            });
            this.dialog = false;
        },
        resetPassword() {
            Api()
                .put("/contacts/resetPassword/" + this.user.id, {
                    name: this.user.name,
                    surname: this.user.surname,
                    idNumber: this.user.idNumber,
                    mobileNumber: this.user.mobileNumber,
                    password: this.password,
                    Password: this.password,
                    telephoneNumber: this.user.telephoneNumber,
                    permissions: this.user.permissions,
                    emailAddress: this.user.emailAddress,
                    isActive: this.user.isActive,
                })
                .then((response) => {
                    this.text = "Password Successfully Reset!";
                    this.snackbar = true;
                    this.$emit("contacts");
                });
            this.password = "";
            this.dialog = false;
        },
        checkLogin() {
            this.permission = this.$store.state.permission;
            if (this.$store.state.isUserLoggedIn === true) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        },
        isEven(n) {
            return n % 2 == 0;
        },
        logout() {
            this.showISPNav = false;
            this.showFNONav = false;
            this.drawer = false;
            this.loggedIn = false;
            this.$store.dispatch("setToken", null);
            this.$store.dispatch("setUser", null);
            this.$store.dispatch("setPermission", null);
            this.$store.dispatch("setCustomerId", null);
            this.$store.dispatch("setCustomerId", null);
            this.$store.dispatch("setIsUserLoggedIn", false);
            this.$store.dispatch("setCurrentOrg", null);
            this.$store.dispatch("setOrgToken", null);
            this.$store.dispatch("setCurrentRoute", null);
            this.$store.dispatch("setOrganisations", null);
            this.$router.push("/login");
            // window.location.reload(true);
            this.isUserLoggedIn = false;
        },
        async getCustomer(customerId) {
            await Api()
                .get("/customers/" + customerId)
                .then((response) => {
                    this.customer = response.data[0];
                });
        },
        async changeOrganisation(item) {
            this.$store.dispatch("setCurrentOrg", item);
            this.$store.dispatch("setOrgToken", item.org.token);
            this.$vuetify.theme.primary = item.org.primaryColour;
            this.$vuetify.theme.secondary = item.org.secondaryColour;
            this.$vuetify.theme.navbarColour = item.org.navbarColour;
            this.$vuetify.theme.navbarTextColour = item.org.navbarTextColour;
            let initialRoute = item.org.frontendRoutes[0];
            if (item.org.frontendRoutes.includes("/fnoDashboard")) {
                initialRoute = "/fnoDashboard";
            } else if (item.org.frontendRoutes.includes("/ispDashboard")) {
                initialRoute = "/ispDashboard";
            } else if (item.org.frontendRoutes.includes("/virtualProviderDashboard")) {
                initialRoute = "/virtualProviderDashboard";
            } else if (item.org.frontendRoutes.includes("/resellerPortal")) {
                initialRoute = "/resellerPortal";
            } else if (item.org.frontendRoutes.includes("/grapeFarmer")) {
                initialRoute = "/grapeFarmer";
            }

            // if (item.org.frontendRoutes.includes("/virtualFnoNetworks")) {
            //   initialRoute='/virtualFno'
            // } else if (item.org.frontendRoutes.includes("/virtualIsp")) {
            //   initialRoute='/virtualIsp'
            // } else if (item.org.frontendRoutes.includes("/virtualServiceAccounts")) {
            //   initialRoute='/virtualServiceAccounts'
            // }
            let route = await item.org.permissions.filter(function (el) {
                return el.url === initialRoute;
            });
            await this.$store.dispatch("setCurrentRoute", route[0]);
            await this.$router.push({
                path: initialRoute
            });
            this.getNavbarList();

        },
        fetchOrganisationAgreements() {
            Api().get('/agreements/contact').then(res => {
                this.outstandingAgreements = res.data
                if(this.outstandingAgreements.length>0){
                    this.persistDocumentAccept = this.outstandingAgreements.filter(x=>this.isFuture(x.date)).length>0
                    if(this.persistDocumentAccept){
                        this.selectedDocument = this.outstandingAgreements[0]
                        this.showOutstandingDocuments = true
                    }
                }
                this.agreementKey++
            })
        },
         isFuture(date) {
            let today = new Date()
            today.setHours(0, 0, 0, 0)
            return new Date(date) >= today
        },

        async setCurrentRoute(item) {
            let url = item;
            let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                return el.url === url;
            });
            await this.$store.dispatch("setCurrentRoute", route[0]);
        },
        async checkSubscription() {
            let appName = "";
            if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging") {
                appName = "OneSignal:testWebApp";
            } else {
                appName = "OneSignal:webApp";
            }
            let result = false;
            await Api()
                .get("/integrations/onesignal/byName/" + appName)
                .then((response) => {
                    if (response.data.id) {
                        result = true;
                    }
                });
            return result;
            // return true
        },
        getNotifications() {
            let userId = this.$store.state.user.id.toString();
            // OneSignal.push(["getNotificationPermission", function(permission) {
            //    console.log(permission)
            // }]);
            //     if(permission==='granted'){

            OneSignal.push(() => {
                OneSignal.setExternalUserId(userId);
                //OneSignal.setEmail(this.$store.state.user.emailAddress);
            });
        },
        reload() {
            this.$socket.on("newApplicationReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("newServiceAccountReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("addIspToNetworkReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("newInstallationReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("newTicketReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("newChangeRequestReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("closedChangeRequestReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("newPackageReceived", () => {
                this.fetchNotifications();
            });
            this.$socket.on("applicationChangeReceived", () => {
                this.fetchNotifications();
            });
        },
    },
    async created() {
        this.config = configData;
        this.fetchNotifications();
        this.reload();
        this.getNavbarList();
        // this.fetchUserGuide();
        this.subscribedToService = await this.checkSubscription();

        if (this.subscribedToService) {
            this.getNotifications();
        } else {
            OneSignal.push(function () {
                OneSignal.showNativePrompt();
            });
            this.getNotifications();
        }
    },
    computed: {
        ...mapState(["isUserLoggedIn", "user"]),
    },
    data() {
        return {
            acceptingAgreement: false,
            outstandingAgreements: [],
            showOutstandingDocuments: false,
            selectedDocument: null,
            persistDocumentAccept: false,
            agreementKey: 0,
            helpUrl: 'https://telecoglue-userguides.s3.eu-west-1.amazonaws.com/ISPUserGuide.md',
            loadingDownload: false,
            helpData: '',
            helpModal: false,
            keyCrumbs: 0,
            crumbsItems: [],
            playerId: null,
            itemNotification: [],
            signalNotifications: [],
            subscribedToService: false,
            isLoading: false,
            contactTypes: [],
            search: "",
            select: null,
            searchResults: [],
            password: "",
            drawer: true,
            dialog: false,
            customer: [],
            loggedIn: false,
            showFNONav: false,
            showISPNav: false,
            permission: "",
            navbarList: [],
            notificationUserRoles: [],
            key: 0,
            management: {
                id: "contactNavbarId",
                icon: "insert_chart",
                title: "Management",
                items: [{
                        icon: "info",
                        title: "Organisation Settings",
                        route: "/organisationDetail",
                    },
                    {
                        title: "User Roles",
                        route: "/userRoles"
                    },
                ],
            },
            ispItems: [{
                    id: "ispContactsNavbarId",
                    icon: "contacts",
                    title: "Organisation Users",
                    route: "/contacts",
                },
                {
                    id: "ispPackagesNavbarId",
                    icon: "view_column",
                    title: "Data Packages",
                    route: "/packagesIsps",
                },
                {
                    id: "ispServiceAccountsNavbarId",
                    icon: "router",
                    title: "Service Accounts",
                    route: "/ispServiceAccounts",
                },
            ],
            items: [{
                    icon: "dashboard",
                    title: "Dashboard",
                    group: false,
                    route: "/resellerPortal",
                    items: [],
                },

                {
                    icon: "dashboard",
                    title: "FNO Dashboard",
                    group: false,
                    route: "/fnoDashboard",
                    items: [],
                },
                {
                    icon: "dashboard",
                    title: "ISP Dashboard",
                    group: false,
                    route: "/ispDashboard",
                    items: [],
                },
                {
                    icon: "dashboard",
                    title: "Dashboard",
                    group: false,
                    route: "/virtualProviderDashboard",
                    items: [],
                },
                {
                    icon: "build",
                    title: "Contractor Faults",
                    group: false,
                    route: "/contractorFaults",
                    items: [],
                },
                {
                    icon: "map",
                    title: "Coverage Map",
                    group: false,
                    route: "/coverageMap",
                    items: [],
                },
                {
                    icon: "map",
                    title: "FNO Coverage Map",
                    group: false,
                    route: "/fnoCoverageMap",
                    items: [],
                },
                {
                    icon: "map",
                    title: "Coverage Map",
                    group: false,
                    route: "/virtualFNOCoverageMap",
                    items: [],
                },
                {
                    icon: "attach_money",
                    title: "Accounts",
                    group: true,
                    items: [
                        // { title: "Dashboard", route: "/billingDashboard" },
                        {
                            title: "ISP Billing",
                            route: "/virtualProviderBilling"
                        },
                        {
                            title: "ISP Billing",
                            route: "/billing"
                        },
                        {
                            title: "Infrastructure Billing",
                            route: "/infrastructureBilling"
                        },

                        //  { title: "Billing History", route: "/billingHistory" },
                        {
                            title: "Financial Overview",
                            route: "/billingOverview"
                        },
                        // { title: "System Invoices", route: "/systemInvoice" },
                        // { title: "Xero Contact Linking", route: "/xeroAccountMapping" },
                    ],
                },
                {
                    icon: "attach_money",
                    title: "Betting",
                    group: true,
                    items: [{
                        title: "Horse Racing",
                        route: "/betting/horseRacing"
                    }],
                },
                {
                    icon: "link",
                    title: "FNO's",
                    group: true,
                    items: [{
                            title: "Network Operators",
                            route: "/virtualFibreNetworkOperators"
                        },
                        {
                            title: "FNO Networks",
                            route: "/virtualFnoNetworks"
                        },
                        {
                            title: "FNO Packages",
                            route: "/virtualFnoPackages"
                        },
                    ],
                },
                {
                    icon: "home_work",
                    title: "Inventory",
                    group: true,
                    items: [{
                            title: "Active Inventory",
                            route: "/inventory/activeInventory"
                        },
                        {
                            title: "Passive Inventory",
                            route: "/inventory/passiveInventory",
                        },
                        {
                            title: "Inventory Types",
                            route: "/inventory/inventoryTypes"
                        },
                        {
                            title: "Inventory Items",
                            route: "/inventory/inventoryItems"
                        },
                        {
                            title: "Orders",
                            route: "/inventory/orders"
                        },
                        {
                            title: "Warehouses",
                            route: "/inventory/warehouse"
                        },
                        {
                            title: "Inventory Movements",
                            route: "/inventoryMovements"
                        },
                        {
                            title: "Stock Adjustments",
                            route: "/stockTake"
                        },
                    ],
                },
                // Billing   //////////////////////////////////////////////////////////////////////////

                {
                    icon: "chrome_reader_mode",
                    title: "Insurance",
                    group: true,
                    items: [{
                        title: "Home Assist",
                        route: "/homeAssist"
                    }],
                },
                {
                    icon: "storefront",
                    title: "ISP's",
                    group: false,
                    route: "/virtualIsp",
                    items: [],
                },
                {
                    icon: "email",
                    title: "Notifications",
                    group: true,
                    items: [{
                            title: "Mass Mail",
                            route: "/emailNotifications"
                        },

                        {
                            title: "Bulk SMS",
                            route: "/bulkSMS"
                        },
                        {
                            title: "Customer Notifications",
                            route: "/mobileBulkNotifications",
                        },
                        {
                            title: "Technician Notifications",
                            route: "/technicianBulkNotifications",
                        },
                    ],
                },
                {
                    icon: "settings_input_antenna",
                    title: "IoT",
                    group: true,
                    items: [{
                        title: "Environment Monitoring",
                        route: "/iot/environment"
                    }],
                },
                {
                  icon: "gps_fixed",
                  title: "GIS",
                  group: true,
                  items: [
                    {
                      id: "fibrePlannerId",
                      icon: "settings_input_component",
                      title: "Fibre Planner (Beta)",
                      route: "/fibrePlanner",
                    },
                    {
                      id: "fibrePlannerId",
                      icon: "settings_input_component",
                      title: "Planner Settings",
                      route: "/fibrePlannerSettings",
                    },
                  ],
                },
                {
                    icon: "pie_chart",
                    title: "Operations",
                    group: true,
                    items: [{
                            id: "switchingCentreNavbarId",
                            icon: "settings_input_component",
                            title: "Operations",
                            group: true,
                            items: [{
                                    id: "switchingCentreNavbarId",
                                    icon: "settings_input_component",
                                    title: "Installations",
                                    route: "/installations",
                                },
                                {
                                    id: "switchingCentreNavbarId",
                                    icon: "settings_input_component",
                                    title: "SLA's",
                                    route: "/serviceLevelAgreement",
                                },
                            ],
                        },
                        {
                            id: "switchingCentreNavbarId",
                            icon: "settings_input_component",
                            title: "Installations",
                            route: "/installations",
                        },
                        {
                            id: "switchingCentreNavbarId",
                            icon: "settings_input_component",
                            title: "Projects",
                            route: "/projects",
                        },
                        {
                            id: "switchingCentreNavbarId",
                            icon: "settings_input_component",
                            title: "SLA's",
                            route: "/serviceLevelAgreement",
                        },

                        // {
                        //   id: "switchingCentreNavbarId",
                        //   icon: "location_on",
                        //   title: "Switching Centres",
                        //   route: "/switchingCentres",
                        // },
                        // {
                        //   icon: "location_on",
                        //   title: "Switching Centres",
                        //   route: "/switchingCentreBasic",
                        // },
                        // {
                        //   id: "locationNodeNavbarId",
                        //   icon: "location_on",
                        //   title: "Nodes",
                        //   route: "/locationNodes",
                        // },
                        // {
                        //   icon: "location_on",
                        //   title: "Nodes",
                        //   route: "/locationNodeBasic",
                        // },
                        // {
                        //   icon: "location_on",
                        //   title: "Networks",
                        //   route: "/locationNetwork",
                        // },
                        // {
                        //   icon: "location_on",
                        //   title: "Networks",
                        //   route: "/locationNetworkBasic",
                        // },
                        {
                            icon: "location_on",
                            title: "Locations",
                            route: "/locations",
                        },
                        // {
                        //   icon: "location_on",
                        //   title: "End Locations",
                        //   route: "/locationBasic",
                        // },
                    ],
                },

                // {
                //   icon: "attach_money",
                //   title: "Investment Overview",
                //   items: [
                //     { title: "Dashboard", route: "/grapeFarmer" }
                //   ]
                // },

                // CUSTOMERS   //////////////////////////////////////////////////////////////////////////
                {
                    id: "customerNavbarId",
                    icon: "bar_chart",
                    title: "Sales",
                    group: true,
                    items: [{
                            icon: "gamepad",
                            title: "Leads",
                            route: "/applications"
                        },
                        {
                            title: "ISP Management",
                            route: "/ispList"
                        },

                        // {
                        //   icon: "gamepad",
                        //   title: "ISP Orders",
                        //   route: "/ispApplications",
                        // },
                        // { icon: "gamepad", title: "Orders", route: "/virtualOwnerApplications" },
                        {
                            icon: "gamepad",
                            title: "Contacts",
                            route: "/contacts"
                        },
                        {
                            icon: "gamepad",
                            title: "Customer Accounts",
                            route: "/customerAccounts"
                        },
                        {
                            icon: "gamepad",
                            title: "FNO Packages",
                            route: "/packagesFno"
                        },
                        // {
                        //   icon: "gamepad",
                        //   title: "FNO Package Categories",
                        //   route: "/packageFnoCats",
                        // },
                        // { title: "All ISP Packages", route: "/packagesIsps" },
                        {
                            title: "Manage ISP Packages",
                            route: "/networkOperators"
                        },
                        {
                            title: "Package Templates",
                            route: "/packageTemplate"
                        },
                        { title: "Promotions", route: "/promotions" },
                        // { title: "Data Packages", route: "/ownPackagesIsps" }
                    ],
                },
                {
                    icon: "link",
                    title: "Shared Networks",
                    group: true,
                    items: [{
                        title: "Virtual Providers",
                        route: "/sharedNetworks"
                    }],
                },
                // Operations   /////////////////////////////////////////////////////////////////////////////////////
                {
                    icon: "build",
                    title: "Technical",
                    group: true,
                    items: [{
                            icon: "gamepad",
                            title: "Devices",
                            route: "/devices"
                        },
                        // { icon: "gamepad", title: "Device Connections", route: "/deviceConnections" },
                        // { icon: "gamepad", title: "Models", route: "/deviceMakeModels" },
                        // { icon: "gamepad", title: "Makes & Brands", route: "/deviceMakes" },
                        {
                            icon: "gamepad",
                            title: "ISP Service Accounts",
                            route: "/serviceAccounts",
                        },
                        {
                            id: "ispServiceAccountsNavbarId",
                            icon: "router",
                            title: "My Service Accounts",
                            route: "/ispServiceAccounts",
                        },
                        {
                            icon: "router",
                            title: "Mass Scripts",
                            route: "/massScripts",
                        },
                        {
                            icon: "router",
                            title: "Radius Server",
                            route: "/radius",
                        },
                        {
                            icon: "headset_mic",
                            title: "Support",
                            route: "/support",
                        },
                        {
                            icon: "report_problem",
                            title: "Faults",
                            route: "/ispFaults",
                        },
                        {
                            icon: "report_problem",
                            title: "ISP Faults",
                            route: "/ispFaultQueue",
                        },
                        {
                            id: "vlanNavbarId",
                            icon: "gamepad",
                            title: "Config Templates",
                            route: "/vlans",
                        },
                    ],
                },
                {
                    icon: "assignment",
                    title: "Tickets",
                    group: true,
                    items: [{
                            title: "All Tickets",
                            route: "/ispTickets"
                        },
                        {
                            title: "All Tickets",
                            route: "/tickets"
                        },
                        {
                            title: "Ticket Categories",
                            route: "/ticketCategory"
                        },
                        {
                            title: "Ticket Templates",
                            route: "/ticketTemplates"
                        },
                        {
                            title: "Canned Responses",
                            route: "/cannedResponses"
                        },
                        
                        {
                            title: "Workflows",
                            route: "/workflows"
                        },
                    ],
                },
                {
                    icon: "confirmation_number",
                    title: "Projects",
                    group: true,
                    items: [{
                            title: "Tasks",
                            route: "/tasks"
                        },
                        {
                            title: "Task Templates",
                            route: "/taskTemplate"
                        }
                    ]
                },
                {
                    icon: "local_shipping",
                    title: "Vehicle Tracking",
                    group: true,
                    items: [{
                            title: "Log Book",
                            route: "/logBook"
                        },
                        {
                            title: "Vehicles",
                            route: "/vehicles"
                        },
                    ],
                },
                {
                    icon: "account_tree",
                    title: "Workflows",
                    group: true,
                    items: [
                        {
                            title: "Forms",
                            route: "/forms"
                        },
                        {
                            title: "Subflows",
                            route: "/workflows/subflows"
                        },
                        {
                            title: "Flows",
                            route: "/workflows/flows"
                        },
                    ],
                },
                // ACCESS   /////////////////////////////////////////////////////////////////////////////////////
                {
                    icon: "home",
                    title: "Access Control",
                    group: true,
                    items: [{
                            title: "Tags",
                            route: "/tags"
                        },
                        {
                            title: "Tag Categories",
                            route: "/tagCategories"
                        },
                        {
                            title: "Communication Protocols",
                            route: "/communicationProtocols",
                        },
                        {
                            title: "Access Points",
                            route: "/accessPoints"
                        },
                        {
                            title: "Access Point Groups",
                            route: "/accessPointGroups"
                        },
                        {
                            title: "Access Devices",
                            route: "/accessDevices"
                        },
                        {
                            title: "Access Transaction Logs",
                            route: "/accessTransactionLogs",
                        },
                    ],
                },

                {
                    icon: "construction",
                    title: "Virtual Service Accounts",
                    group: false,
                    route: "/virtualServiceAccounts",
                    items: [],
                },
                {
                    id: "contactNavbarId",
                    icon: "insert_chart",
                    title: "Management",
                    group: true,
                    items: [
                        // { icon: "contacts", title: "Contacts", route: "/contacts" },
                        {
                            icon: "info",
                            title: "Organisation Details",
                            route: "/organisationDetail",
                        },
                        {
                            title: "Connections",
                            route: "/connections"
                        },
                        {
                            title: "Sub Organisations",
                            route: "/organisation/isp"
                        },

                        // { id: "customerTypeNavbarId", icon: "person", title: "Customer Types", route: "/customerTypes"},
                        {
                            id: "locationTypeNavbarId",
                            icon: "location_on",
                            title: "Location Types",
                            route: "/locationTypes",
                        },
                        {
                            title: "Organisation Applications",
                            route: "/organisationApplications",
                        },
                        {
                            title: "Integrations",
                            route: "/integrations"
                        },
                        {
                            title: "Statistics",
                            route: "/statistics"
                        },
                        {
                            title: "User Roles",
                            route: "/userRoles"
                        },
                    ],
                },
            ],
            admin: {
                icon: "perm_identity",
                title: "Glue Admin",
                group: true,
                items: [{
                        title: "AWS Dashboard",
                        route: "/awsMonitoring"
                    },
                    {
                        title: "Billing",
                        route: "/glueBilling"
                    },
                    {
                        id: "contactTypeNavbarId",
                        icon: "contacts",
                        title: "Contact Types",
                        route: "/contactTypes",
                    },
                    {
                        title: "Agreements",
                        route: "/glueAgreements"
                    },
                    {
                        title: "Micro Service Monitoring",
                        route: "/microServiceMonitoring"
                    },
                    {
                        title: "Modules",
                        route: "/modules"
                    },
                    {
                        title: "Organisations",
                        route: "/organisations"
                    },
                    {
                        title: "User Activity",
                        route: "/userActivity"
                    },
                    {
                        title: "Network Management",
                        route: "/nmsSettings"
                    },
                    {
                        title: "Organisation Types",
                        route: "/organisationTypes"
                    },

                    {
                        title: "Regions",
                        route: "/regions"
                    },
                    {
                        title: "Route Mapping",
                        route: "/routeMapping"
                    },
                    {
                        title: "Speed Profiles",
                        route: "/speedProfiles"
                    },
                    {
                        title: "Scripts",
                        route: "/scripts"
                    },
                    {
                        title: "Submodules",
                        route: "/submodules"
                    },
                    {
                        id: "deviceTypeNavbarId",
                        icon: "gamepad",
                        title: "Type of Devices",
                        route: "/deviceTypes",
                    },
                    {
                        title: "User Groups",
                        route: "/userGroups"
                    },
                    {
                        title: "Workflow Settings",
                        route: "/workflowSettings"
                    },
                ],
            },
            mini: false,
            miniIsp: false,
            right: null,
            snackbar: false,
            customerDialog: false,
            allRoutes: [],
        };
    },
};
</script>
